<template>
  <div>
    <b-table
      small
      responsive
      show-empty
      bordered
      :items="zeilen"
      :fields="fields"
      :busy="laedt"
      class="text-center"
    >
      <template v-slot:cell(hotel)="row">
        <div class="text-left">
          <span v-if="row.item.zimmer">{{ hotelLabel(row.item) }}</span>
          <b-badge v-else variant="warning">{{ $t("global.hotelopen") }}</b-badge>
        </div>
      </template>
      <template v-for="nacht in naechte" v-slot:[`cell(${nacht})`]="row">
        <span :key="nacht" :class="{ 'text-danger font-weight-bold': ueberbucht(row.item, nacht) }">
          {{ row.item.belegung[nacht] || "" }}<span v-if="row.item.belegung[nacht] && row.item.kontingent != null"> / {{ row.item.kontingent }}</span>
        </span>
      </template>
      <template #table-busy>
        <div class="text-center text-primary my-2"><b-spinner class="align-middle"></b-spinner></div>
      </template>
      <template #empty>
        <div class="text-center text-primary my-2">
          <strong>{{ $t("global.nodataavailable") }}</strong>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import AppApi from "@/api/AppApi";
import { apiErrorToAlert } from "@/utils/Errorhandler";

/**
 * Belegung pro Hotelkontingent und Nacht (Datum = Abend der Übernachtung). Rot = Kontingent überschritten.
 * reloadKey ändern, um neu zu laden.
 */
export default {
  name: "ZimmerBelegung",
  props: {
    veranstaltung: { type: String, required: false },
    lehrgang: { type: String, required: false },
    hotelkontingente: { type: Array, default: () => [] },
    reloadKey: { type: Number, default: 0 },
  },
  data() {
    return {
      naechte: [],
      zeilen: [],
      laedt: false,
    };
  },
  computed: {
    fields() {
      return [
        { key: "hotel", label: this.$t("global.hotel"), thClass: "text-left" },
        ...this.naechte.map((n) => ({ key: n, label: n.substring(0, 6) })),
      ];
    },
  },
  watch: {
    reloadKey() {
      this.laden();
    },
  },
  mounted() {
    this.laden();
  },
  methods: {
    laden() {
      const params = this.lehrgang ? { lehrgang: this.lehrgang } : { veranstaltung: this.veranstaltung };
      if (!params.lehrgang && !params.veranstaltung) return;
      this.laedt = true;
      AppApi.get("zimmer-belegung/", { params })
        .then((response) => {
          this.naechte = response.data.naechte || [];
          this.zeilen = response.data.zeilen || [];
        })
        .catch((e) => this.$notify(apiErrorToAlert(e)))
        .finally(() => {
          this.laedt = false;
        });
    },
    hotelLabel(zeile) {
      if (!this.lehrgang) return zeile.bezeichnung;
      const kontingent = this.hotelkontingente.find((k) => k.id === zeile.zimmer);
      const modul = kontingent?.veranstaltung ? kontingent.veranstaltung.bezeichnung : this.$t("global.allmodules");
      return `${zeile.bezeichnung || ""} (${modul})`;
    },
    ueberbucht(zeile, nacht) {
      return zeile.kontingent != null && (zeile.belegung[nacht] || 0) > zeile.kontingent;
    },
  },
};
</script>
